import { AxiosError, isAxiosError } from 'axios'

type TAxiosError = 'axios-error'
type TStockError = 'stock-error'
type TUnknownError = 'unknown-error'
type TTransformerError = 'transformer-error'

interface IErrorBase<T> {
  error: Error | AxiosError<T>
  type: TAxiosError | TStockError
}

interface IAxiosError<T> extends IErrorBase<T> {
  error: AxiosError<T>
  type: TAxiosError
}
interface IStockError<T> extends IErrorBase<T> {
  error: Error
  type: TStockError
}

interface IUnknownError {
  error: any
  type: TUnknownError
}

export interface ITransformerError {
  error: {
    message: string
    data?: any
  }
  type: TTransformerError
}

type TGeneratedError<T> = IAxiosError<T> | IStockError<T> | IUnknownError

export interface IThunkReject<T> {
  rejectValue: TGeneratedError<T> | ITransformerError
}

export const axiosErrorHandler =
  <T>(
    callback: (err: IAxiosError<T> | IStockError<T> | IUnknownError) => void,
  ) =>
  (
    error: Error | AxiosError<T>,
  ): IAxiosError<T> | IStockError<T> | IUnknownError => {
    if (isAxiosError(error)) {
      const axiosError: IAxiosError<T> = {
        error,
        type: 'axios-error',
      }
      callback(axiosError)
      return axiosError
    } else if (error instanceof Error) {
      const stockError: IStockError<T> = {
        error,
        type: 'stock-error',
      }
      callback(stockError)
      return stockError
    } else {
      const unknownError: IUnknownError = {
        error,
        type: 'unknown-error',
      }
      callback(unknownError)
      return unknownError
    }
  }
